/* Faro — navegación de documentación (prototipo 0.1)
 * 1. Oculta prefijos numéricos de orden ("01. Instalación" → "Instalación").
 * 2. Modo menú: "- Etiqueta" en la navegación secundaria = ítem indentado.
 * 3. Agrupa artículos por subsección (tag interno "#sub-Nombre").
 * 4. Marca el artículo actual y abre su sección.
 * 5. Anterior / Siguiente según el orden del árbol.
 * 6. Índice (TOC) a partir de H2/H3.
 * 7. "¿Te sirvió?" → evento GA4 article_feedback.
 * 8. Copiar código, modo oscuro, menú en celulares.
 */
(function () {
    'use strict';

    var PREFIX = /^\s*\d+[.)\-]\s+/;
    var SUB = '#sub-';

    function strip(text) { return text.replace(PREFIX, ''); }
    function samePath(a, b) {
        var n = function (p) { return p.replace(/\/+$/, '') || '/'; };
        return n(a) === n(b);
    }

    /* 1. Prefijos */
    document.querySelectorAll('.f-strip').forEach(function (el) {
        if (el.children.length === 0) el.textContent = strip(el.textContent);
    });
    if (PREFIX.test(document.title)) document.title = strip(document.title);
    /* Íconos de Faro (archivos faro-icon-*.svg): se pintan con el color de la marca y se adaptan al modo oscuro */
    document.querySelectorAll('.f-card-icon img').forEach(function (img) {
        var src = img.getAttribute('src') || '';
        if (!/faro-icon-|\/demo-icons\//.test(src)) return;
        var span = document.createElement('span');
        span.className = 'f-icon-mask';
        span.style.setProperty('--f-icon', 'url("' + src.replace(/"/g, '%22') + '")');
        img.replaceWith(span);
    });

    document.querySelectorAll('.f-monogram').forEach(function (el) {
        el.textContent = el.textContent.trim().charAt(0).toUpperCase();
    });

    /* Buscador de la portada: escribe solo ejemplos de preguntas (los artículos destacados) */
    var heroSearch = document.querySelector('.f-hero-search[data-examples]');
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (heroSearch && !reduce) {
        var examples = heroSearch.getAttribute('data-examples').split('|').map(function (t) { return strip(t).trim(); }).filter(Boolean);
        var out = heroSearch.querySelector('.f-hero-search-typed');
        if (examples.length && out) {
            var ex = 0, ch = 0, deleting = false, paused = false, gen = 0;
            var later = function (ms) { var g = gen; setTimeout(function () { if (g === gen) tick(); }, ms); };
            var tick = function () {
                if (paused) return;
                var word = examples[ex];
                if (!deleting) {
                    ch++;
                    out.textContent = word.slice(0, ch);
                    heroSearch.classList.add('is-typing');
                    if (ch === word.length) { deleting = true; return later(1800); }
                    return later(55 + Math.random() * 45);
                }
                ch--;
                out.textContent = word.slice(0, ch);
                if (ch === 0) {
                    deleting = false;
                    ex = (ex + 1) % examples.length;
                    heroSearch.classList.remove('is-typing');
                    return later(900);
                }
                later(28);
            };
            later(1200);
            /* Al pasar el mouse o enfocar, se frena y vuelve el texto de ayuda */
            var stop = function () { paused = true; gen++; out.textContent = ''; heroSearch.classList.remove('is-typing'); };
            var resume = function () { if (!paused) return; paused = false; ch = 0; deleting = false; gen++; later(600); };
            heroSearch.addEventListener('mouseenter', stop);
            heroSearch.addEventListener('focus', stop);
            heroSearch.addEventListener('mouseleave', resume);
            heroSearch.addEventListener('blur', resume);
        }
    }

    /* Portada: el encabezado se vuelve sólido al hacer scroll */
    var header = document.querySelector('.f-header');
    if (header && document.body.classList.contains('home-template')) {
        var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 40); };
        onScroll();
        window.addEventListener('scroll', onScroll, { passive: true });
    }

    /* Atajo "/" para abrir la búsqueda */
    document.addEventListener('keydown', function (e) {
        if (e.key !== '/' || e.metaKey || e.ctrlKey) return;
        var t = e.target;
        if (t && (t.isContentEditable || /^(INPUT|TEXTAREA|SELECT)$/.test(t.tagName))) return;
        var btn = document.querySelector('[data-ghost-search]');
        if (btn) { e.preventDefault(); btn.click(); }
    });

    /* 2. Modo menú */
    document.querySelectorAll('[data-mode="menu"] .f-item').forEach(function (li) {
        var label = li.getAttribute('data-label') || '';
        var a = li.querySelector('a');
        if (/^\s*-\s+/.test(label)) {
            li.classList.add('f-item-child');
            a.textContent = strip(label.replace(/^\s*-\s+/, ''));
        } else {
            li.classList.add('f-item-top');
        }
    });

    /* 3. Subsecciones */
    function subName(li) {
        var tags = (li.getAttribute('data-tags') || '').split('|');
        for (var i = 0; i < tags.length; i++) {
            if (tags[i].indexOf(SUB) === 0) return tags[i].slice(SUB.length).trim();
        }
        return null;
    }
    function groupSubs(list) {
        var items = Array.prototype.slice.call(list.children);
        var groups = {};
        var order = [];
        items.forEach(function (li) {
            var name = subName(li);
            if (!name) return;
            if (!groups[name]) {
                var group = document.createElement('li');
                group.className = 'f-sub';
                group.innerHTML = '<span class="f-sub-title"></span><ul class="f-sub-items"></ul>';
                group.querySelector('.f-sub-title').textContent = strip(name);
                groups[name] = group;
                order.push(name);
                list.insertBefore(group, li);
            }
            groups[name].querySelector('ul').appendChild(li);
        });
        /* Cada subsección queda en la posición de su primer artículo: se respeta el orden numérico */
    }
    document.querySelectorAll('.f-section-items, [data-group-subs]').forEach(groupSubs);

    /* 4. Actual */
    var path = window.location.pathname;
    var treeLinks = Array.prototype.slice.call(document.querySelectorAll('.f-tree .f-item > a'));
    var current = null;
    treeLinks.forEach(function (a) {
        if (samePath(new URL(a.href, location.href).pathname, path)) {
            current = a;
            a.setAttribute('aria-current', 'page');
            var section = a.closest('.f-section');
            if (section) section.classList.add('is-open');
            var sub = a.closest('.f-sub');
            var crumb = document.querySelector('.f-breadcrumb-sub');
            if (sub && crumb) {
                crumb.querySelector('span:last-child').textContent = sub.querySelector('.f-sub-title').textContent;
                crumb.hidden = false;
            }
        }
    });
    document.querySelectorAll('.f-section-link').forEach(function (a) {
        if (samePath(new URL(a.href, location.href).pathname, path)) {
            a.setAttribute('aria-current', 'page');
            a.closest('.f-section').classList.add('is-open');
        }
    });

    /* 5. Anterior / Siguiente (orden del árbol, incluye subsecciones) */
    var pager = document.querySelector('.f-pager');
    if (pager && current) {
        /* Solo artículos: los ítems que apuntan a una sección (/tag/…) no cuentan para anterior/siguiente */
        var ordered = Array.prototype.slice.call(document.querySelectorAll('.f-tree .f-item > a')).filter(function (a) {
            return a === current || !/\/tag\//.test(new URL(a.href, location.href).pathname);
        });
        var i = ordered.indexOf(current);
        var html = '';
        if (i > 0) {
            html += '<a class="f-pager-prev" href="' + ordered[i - 1].href + '"><span>' + pager.getAttribute('data-label-prev') + '</span><strong></strong></a>';
        }
        if (i > -1 && i < ordered.length - 1) {
            html += '<a class="f-pager-next" href="' + ordered[i + 1].href + '"><span>' + pager.getAttribute('data-label-next') + '</span><strong></strong></a>';
        }
        pager.innerHTML = html;
        var prev = pager.querySelector('.f-pager-prev strong');
        var next = pager.querySelector('.f-pager-next strong');
        if (prev) prev.textContent = ordered[i - 1].textContent;
        if (next) next.textContent = ordered[i + 1].textContent;
    }

    /* 6. TOC */
    var toc = document.querySelector('.f-toc');
    var content = document.querySelector('.f-content');
    if (toc && content) {
        var heads = content.querySelectorAll('h2, h3');
        if (heads.length > 1) {
            var ul = document.createElement('ul');
            var anchorLabel = content.getAttribute('data-anchor-label') || '#';
            heads.forEach(function (h, n) {
                if (!h.id) h.id = 'h-' + n;
                var anchor = document.createElement('a');
                anchor.className = 'f-anchor';
                anchor.href = '#' + h.id;
                anchor.textContent = '#';
                anchor.setAttribute('aria-label', anchorLabel);
                h.insertBefore(anchor, h.firstChild);
                var li = document.createElement('li');
                li.className = 'f-toc-' + h.tagName.toLowerCase();
                var a = document.createElement('a');
                a.href = '#' + h.id;
                a.textContent = h.textContent.replace(/^#/, '');
                li.appendChild(a);
                ul.appendChild(li);
            });
            var title = document.createElement('p');
            title.className = 'f-toc-title';
            title.textContent = toc.getAttribute('data-toc-title');
            toc.appendChild(title);
            toc.appendChild(ul);
            if ('IntersectionObserver' in window) {
                var links = ul.querySelectorAll('a');
                var obs = new IntersectionObserver(function (entries) {
                    entries.forEach(function (e) {
                        if (!e.isIntersecting) return;
                        links.forEach(function (l) {
                            l.classList.toggle('is-active', l.getAttribute('href') === '#' + e.target.id);
                        });
                    });
                }, { rootMargin: '0px 0px -70% 0px' });
                heads.forEach(function (h) { obs.observe(h); });
            }
        } else {
            toc.remove();
        }
    }

    /* 7. Feedback */
    var fb = document.querySelector('[data-feedback]');
    if (fb) {
        fb.addEventListener('click', function (e) {
            var btn = e.target.closest('[data-feedback-value]');
            if (!btn) return;
            var value = btn.getAttribute('data-feedback-value');
            if (typeof window.gtag === 'function') {
                window.gtag('event', 'article_feedback', { helpful: value, page_path: path });
            }
            fb.querySelectorAll('button').forEach(function (b) { b.hidden = true; });
            fb.querySelector('.f-feedback-thanks').hidden = false;
        });
    }

    /* 8a. Copiar código */
    var copyLabel = (content && content.getAttribute('data-copy-label')) || 'Copy';
    var copiedLabel = (content && content.getAttribute('data-copied-label')) || 'Copied';
    document.querySelectorAll('.f-content pre').forEach(function (pre) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'f-copy';
        b.textContent = copyLabel;
        b.setAttribute('aria-label', copyLabel);
        b.addEventListener('click', function () {
            var code = pre.querySelector('code') || pre;
            navigator.clipboard && navigator.clipboard.writeText(code.innerText).then(function () {
                b.textContent = copiedLabel;
                setTimeout(function () { b.textContent = copyLabel; }, 1500);
            });
        });
        pre.appendChild(b);
    });

    /* 8b. Modo oscuro */
    var tt = document.querySelector('.f-theme-toggle');
    if (tt) {
        tt.addEventListener('click', function () {
            var root = document.documentElement;
            var isDark = root.getAttribute('data-theme') === 'dark' ||
                (!root.getAttribute('data-theme') && window.matchMedia('(prefers-color-scheme: dark)').matches);
            var next = isDark ? 'light' : 'dark';
            root.setAttribute('data-theme', next);
            try { localStorage.setItem('faro-theme', next); } catch (e) {}
        });
    }

    /* 8c. Menú en celulares */
    var mt = document.querySelector('.f-menu-toggle');
    var sb = document.getElementById('f-sidebar');
    if (mt && sb) {
        /* Cajón del celular: fondo oscurecido, se cierra tocando afuera o con Escape */
        var scrim = document.createElement('div');
        scrim.className = 'f-scrim';
        document.body.appendChild(scrim);
        var setOpen = function (open) {
            sb.classList.toggle('is-open', open);
            scrim.classList.toggle('is-open', open);
            document.documentElement.classList.toggle('f-no-scroll', open);
            mt.setAttribute('aria-expanded', open ? 'true' : 'false');
        };
        mt.addEventListener('click', function () { setOpen(!sb.classList.contains('is-open')); });
        scrim.addEventListener('click', function () { setOpen(false); });
        document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && sb.classList.contains('is-open')) { setOpen(false); mt.focus(); } });
    } else if (mt) {
        mt.hidden = true;
    }
})();
